import { CellText } from './cell-text';
import { isValidHttpUrl } from './types';

export function CellUrl({
  className,
  url,
  name,
  tabIndex,
}: {
  name?: string | null;
  url: string | undefined | null;
  className?: string;
  tabIndex?: number;
}) {
  if (!url) {
    return <CellText className={className}>{name ?? '—'}</CellText>;
  }
  const urlHref = isValidHttpUrl(url) ? url : `https://${url}`;
  return (
    <a className={`group ${className}`} href={urlHref} rel="noreferrer" target="_blank" tabIndex={tabIndex}>
      <CellText className="decoration-primary decoration-2 group-hover:underline">{name ?? url ?? '—'}</CellText>
    </a>
  );
}
